import "primeflex/primeflex.css";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext"; 
import { useEffect, useRef, useState } from "react";
import { GENDERS } from "../constants/app-constants";
import DropdownMultiSelectWithTitle from "./common/dropdowns/DropdownMultiSelectWithTitle";
import DropdownRangeSlider from "./common/dropdowns/DropdownRangeSlider";
import { useMultiSelectScroll } from "../hook/useMultiSelectScroll";
import { Sidebar } from "primereact/sidebar";
import DropdownSelectDayTime from "./common/dropdowns/DropdownSelectDayTime";
import { HEADER_INDEX } from "../constants/app-constants";
const defaultTagsOptionState = {
  title: [{ key: "", value: "" }],
};

const defaultDaysOptionState = [{ key: "", value: "" }];

const defaultInstructorStylesOptionState = {
  title: [{ key: "", value: "" }],
};

const TrainerHeroSection = ({ props, tagsOption, instructorStylesOption, daysOption, usingSidebar = false, searchSidebarVisible, onCloseSearchSidebar }) => {
  const [selectedTimeState, setSelectedTime] = useState(props.selectedTime);
  const [selectedDayState, setSelectedDay] = useState(props.selectedDay);
  const [tagOptionState, setTagsOptionState] = useState(tagsOption ?? defaultTagsOptionState);
  const [daysOptionState, setDaysOptionState] = useState(daysOption.length > 0 ? daysOption : defaultDaysOptionState);
  const [instructorStylesOptionState, setInstructorStylesOptionState] = useState(instructorStylesOption ?? defaultInstructorStylesOptionState);

  const [selectedPriceState, setSelectedPriceState] = useState(props.selectedPrice);
  const [selectedCourseContentState, setSelectedCourseContent] = useState(props.selectedCourseContent);
  const [sortByState, setSortBy] = useState(props.sortBy);
  const [selectedCountryState, setSelectedCountry] = useState(props.selectCountry);
  const [selectedGenderState, setSelectedGender] = useState(props.selectedGender);
  const [selectedSpokenLanguageState, setSelectedSpokenLanguage] = useState(props.selectedSpokenLanguage);
  const [selectedTeacherStyleState, setSelectedTeacherStyle] = useState(props.selectedTeacherStyle);
  const [searchText, setSearchText] = useState(props.searchText);

  const timeFilterRef = useRef(null);
  const tuitionFeeFilterRef = useRef(null);
  const courseContentFilterRef = useRef(null);
  const teachingStyleFilterRef = useRef(null);

  useEffect(() => {
    props.onFilterTimeChange(selectedTimeState);
    props.onFilterDayChange(selectedDayState);
    props.onFilterPriceChange(selectedPriceState);
    props.onFilterCourseContentChange(selectedCourseContentState);

    props.onSortOptionChange(sortByState);
  }, [selectedTimeState, selectedDayState, selectedPriceState, selectedCourseContentState, sortByState]);

  useEffect(() => {
    props.onFilterCountryChange(selectedCountryState);
    props.onFilterGenderChange(selectedGenderState);
    props.onFilterLanguageChange(selectedSpokenLanguageState);
    props.onFilterStyleChange(selectedTeacherStyleState);
  }, [selectedCountryState, selectedGenderState, selectedSpokenLanguageState, selectedTeacherStyleState]);

  useEffect(() => {
    props.onFilterPriceChange(selectedPriceState);
  }, [selectedPriceState]);

  // Use global scroll detection hook
  useMultiSelectScroll();

  const countryOptionTemplate = (option) => {
    return (
      <div className="justify-content-center align-items-center flex gap-1">
        <div className="keduall-icon flag-circle-country small-size justify-content-center align-items-center flex">
          <span className={`flag img flex fi fi-${option.code.toLowerCase()}`} />
        </div>
        <div className="flex keduall-typography text-16-normal-400 text-default-txt">{option.name}</div>
      </div>
    );
  };

  const languageOptionTemplate = (option) => {
    const code = option.code.split("-")[1].toLowerCase();
    return (
      <div className="justify-content-center align-items-center flex gap-1">
        <div className="keduall-icon flag-circle-country small-size justify-content-center align-items-center flex">
          <span className={`flag img flex fi fi-${code}`} />
        </div>
        <div className="flex keduall-typography text-16-normal-400 text-default-txt">{option.name}</div>
      </div>
    );
  };

  const pickTimeProps = {
    stepMinute: props.filterValue.lessonTimePickerStepValue,
    dayPickerTitle: props.translationData.lessonDayPickerTitle,
    timePickerTitle: props.translationData.lessonTimePickerTitle,
    dropdownPlaceholder: props.translationData.lessonFilterPlaceholder,
  };

  const tuitonFeeProps = {
    min: props.tuitionFeeRangeMinValue,
    max: props.tuitionFeeRangeMaxValue,
    step: props.tuitionFeeRangeStepValue,
    placeholder: props.translationData.tuitionFeeFilterPlaceholder,
    rangeHeader: props.translationData.tuitionFeeRangeHeader,
    minHeader: props.translationData.tuitionFeeRangeMin,
    maxHeader: props.translationData.tuitionFeeRangeMax,
    currency: props.currency,
    ratesData: props.ratesData,
    defaultCurrency: props.defaultCurrency,
  };

  const sortByProps = {
    placeholder: props.translationData.sortByPlaceholder,
    options: [
      props.translationData.filterLabel.byPopularitySortLabel,
      props.translationData.filterLabel.topRecommendedSortLabel,
      props.translationData.filterLabel.highestPriceSortLabel,
      props.translationData.filterLabel.lowestPriceSortLabel,
      props.translationData.filterLabel.mostReviewsSortLabel,
      props.translationData.filterLabel.highestRatingSortLabel,
    ],
  };

  const genderProps = {
    placeholder: props.translationData.genderFilterPlaceholder,
    options: [
      { name: props.translationData.filterLabel.maleFilterLabel, value: GENDERS.MALE },
      { name: props.translationData.filterLabel.femaleFilterLabel, value: GENDERS.FEMALE },
    ],
  };

  const onClear = () => {
    setSortBy(null);
    setSelectedCountry(null);
    setSelectedGender(null);
    setSelectedSpokenLanguage(null);

    if (timeFilterRef) {
      timeFilterRef.current.handleClear();
    }

    if (tuitionFeeFilterRef) {
      tuitionFeeFilterRef.current.handleClear();
    }

    if (courseContentFilterRef) {
      courseContentFilterRef.current.handleClear();
    }

    if (teachingStyleFilterRef) {
      teachingStyleFilterRef.current.handleClear();
    }
    props.onSearchTextChange("");
    setSearchText("");
    props.onFilterReset();
  };

  const clearButtonTemplate = (onClearClick, isShowNValueNumber = false, numberValue = 0) => {
    return isShowNValueNumber ? (
      <div className="absolute z-5 flex flex-row keduall-form dropdown-input group-two-icon gap-3">
        <div className="flex keduall-typography text-16-normal-400 text-default-txt">({numberValue})</div>
        <Button
          icon="pi pi-times z-5 flex"
          className="p-button-text keduall-form dropdown-input icon w-max"
          onClick={(e) => {
            e.stopPropagation();
            onClearClick(null);
          }}
        />
      </div>
    ) : (
      <Button
        icon="pi pi-times z-5 flex"
        className="p-button-text absolute keduall-form dropdown-input icon icon-times-circle"
        onClick={(e) => {
          e.stopPropagation();
          onClearClick(null);
        }}
      />
    );
  };

  const getOptionName = (option) => {
    if (!option) return null;
    // Map each value to its corresponding name
    const names = option.map((value) => {
      const country = props.listCountryOption.find((option) => option.code === value);
      return country ? country.name : value;
    });

    return names.join(",");
  };

  const getGenderName = (option) => {
    if (!option) return null;
    // Map each value to its corresponding name
    const names = option.map((value) => {
      const gender = genderProps.options.find((option) => option.value === value);
      return gender ? gender.name : value;
    });

    return names.join(",");
  };

  const getLanguageName = (option) => {
    if (!option) return null;
    // Map each value to its corresponding name
    const names = option.map((value) => {
      const language = props.languages.find((option) => option.code === value);
      return language ? language.name : value;
    });

    return names.join(",");
  };

  const valueTemplate = (option, props) => {
    if (option) {
      return <div className="text-default-txt keduall-typography text-16-semibold-600">{option}</div>;
    } else {
      return <div className="text-secondary-txt keduall-typography text-16-normal-400">{props.placeholder}</div>;
    }
  };

  const dropdownIconTemplate = (
    <i className="pi absolute cursor-pointer pi-angle-down keduall-form dropdown-input keduall-typography text-default icon-angle-down-small z-4 flex"></i>
  );

  const transformedLanguages = props.languages.map((lang) => ({
    ...lang,
    filterText: lang.alternativeNames?.map((name) => name.toLowerCase()).join(" ") || "",
  }));

  useEffect(() => {
    if (searchSidebarVisible) {
      setTimeout(() => {
        const sidebar = document.querySelector(".p-sidebar-left");
        if (sidebar) {
          sidebar.style.zIndex = "10001";
        }
      }, 0);
    }
  }, [searchSidebarVisible]);

  const onSearchTextClear = (e) => {
    e.stopPropagation();
    setSearchText("");
    props.onSearchTextChange("");
  }

  const onSearchTextChange = (e) => {
    setSearchText(e.target.value);
    props.onSearchTextChange(e.target.value);
  };

  const handleDropdownShow = (e) => {
    const panel = e?.target?.overlay || document.querySelector('.p-dropdown-panel');
    if (panel) {
      const sidebar = document.querySelector(".p-sidebar-left");
      if (sidebar) {
        panel.style.zIndex = `${HEADER_INDEX + 2}`;
      } else {
        panel.style.zIndex = `${HEADER_INDEX - 1}`;
      }
    }
  };

  const handleDropdownHide = (e) => {
    const panel = e?.target?.overlay || document.querySelector('.p-dropdown-panel');
    if (panel) {
      panel.style.zIndex = '';
    }
  };

  const handleMultiSelectShow = (e) => {
    const panel = e?.target?.overlay || document.querySelector('.p-multiselect-panel');
    if (panel) {
      const sidebar = document.querySelector(".p-sidebar-left");
      if (sidebar) {
        panel.style.zIndex = `${HEADER_INDEX + 2}`;
      } else {
        panel.style.zIndex = `${HEADER_INDEX - 1}`;
      }
    }
  };

  const handleMultiSelectHide = (e) => {
    const panel = e?.target?.overlay || document.querySelector('.p-multiselect-panel');
    if (panel) {
      panel.style.zIndex = '';
    }
  };

  return (
    <>
      <div class="w-full flex flex-column gap-4 mt-5">
        <div className="flex flex-column gap-3 w-full">
          {/* Filtered criteria by Lesson */}
          <div className="flex flex-row gap-3 align-content-center justify-content-center flex-wrap lg:flex-nowrap w-full">
            <div className="flex flex-column w-full">
              <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.lessonTimeFilterHeader}</div>
              <DropdownSelectDayTime
                ref={timeFilterRef}
                commonProps={pickTimeProps}
                selectedTimeState={selectedTimeState}
                selectedDayState={selectedDayState}
                onPickDay={setSelectedDay}
                onPickTime={setSelectedTime}
                dayOptions={daysOption}
                labelKey="value"
                valueKey="key"
              />
            </div>
            <div className="flex flex-column w-full">
              <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.tuitionFeeFilterHeader}</div>
              <DropdownRangeSlider ref={tuitionFeeFilterRef} props={tuitonFeeProps} onChange={setSelectedPriceState} selectedPriceState={selectedPriceState} />
            </div>
            <div className="flex flex-column w-full">
              <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.courseContentFilterHeader}</div>
              <DropdownMultiSelectWithTitle
                ref={courseContentFilterRef}
                props={{ items: tagOptionState, labelKey: "value", valueKey: "key", placeholder: props.translationData.courseContentFilterPlaceholder }}
                onChange={setSelectedCourseContent}
                value={selectedCourseContentState}
              />
            </div>
            <div className="flex flex-column w-full">
              <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.sortByHeader}</div>
              <Dropdown
                className="keduall-form dropdown-input custom-height-auto dropdown-content-container no-padding custom-dropdown"
                options={sortByProps.options}
                placeholder={sortByProps.options[0] ?? sortByProps.placeholder}
                panelClassName="keduall-form dropdown-input-panel keduall-typography text-16-normal-400 text-default-txt w-auto custom-index"
                value={sortByState}
                onShow={(e) => handleDropdownShow(e)}
                onHide={(e) => handleDropdownHide(e)}
                onChange={(e) => setSortBy(e.value)}
                showClear={true}
                clearIcon={clearButtonTemplate(setSortBy)}
                dropdownIcon={dropdownIconTemplate}
                collapseIcon={dropdownIconTemplate}
                valueTemplate={valueTemplate}
                style={{ height: "2.7rem" }}
                appendTo="self"

              />
            </div>
          </div>

          {/* Filtered criteria by Tutor */}
          <div className="relative flex flex-row gap-3 align-content-center justify-content-center flex-wrap lg:flex-nowrap w-full">
            <div className=" flex flex-column w-full md:w3">
              <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.nationalityFilterHeader}</div>
              <MultiSelect
                className="keduall-form multi-select-input pr-4 custom-multi-select custom-pr-175 custom-placeholder keduall-typography text-16-semibold-600 text-default-txt w-full"
                options={props.listCountryOption}
                optionLabel="name"
                optionValue="code"
                placeholder={props.listCountryOption?.[0]?.name ?? props.translationData.nationalityFilterPlaceholder}
                itemTemplate={countryOptionTemplate}
                selectOnFocus={false}
                showSelectAll={false}
                showClear={true}
                filter
                appendTo="self"
                panelClassName="keduall-form dropdown-input-panel keduall-typography text-16-normal-400 text-default-txt w-webkit-fill-available"
                onChange={(e) => setSelectedCountry(e.value)}
                value={selectedCountryState}
                clearIcon={clearButtonTemplate(setSelectedCountry, true, selectedCountryState?.length)}
                dropdownIcon={dropdownIconTemplate}
                tooltip={getOptionName(selectedCountryState)}
                onShow={(e) => handleMultiSelectShow(e)}
                onHide={(e) => handleMultiSelectHide(e)}
                tooltipOptions={{
                  className: "keduall-tooltip",
                  position: "bottom",
                }}
              />
            </div>
            <div className="flex flex-column w-full md:w3">
              <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.genderFilterHeader}</div>
              <MultiSelect
                className="keduall-form form-without-search multi-select-input custom-multi-select custom-placeholder keduall-typography text-16-semibold-600 text-default-txt w-full"
                options={genderProps.options}
                optionLabel="name"
                optionValue="value"
                placeholder={genderProps.options?.[0]?.name ?? genderProps.placeholder}
                selectOnFocus={false}
                showSelectAll={false}
                appendTo="self"
                panelClassName="keduall-form dropdown-input-panel keduall-typography text-16-normal-400 text-default-txt w-webkit-fill-available"
                value={selectedGenderState}
                showClear={true}
                panelHeaderTemplate=""
                onShow={(e) => handleMultiSelectShow(e)}
                onHide={(e) => handleMultiSelectHide(e)}
                onChange={(e) => setSelectedGender(e.value)}
                clearIcon={clearButtonTemplate(setSelectedGender)}
                dropdownIcon={dropdownIconTemplate}
                tooltip={getGenderName(selectedGenderState)}
                tooltipOptions={{
                  className: "keduall-tooltip",
                  position: "bottom",
                }}
              />
            </div>
            <div className="flex flex-column w-full md:w3">
              <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.languageSpokenFilterHeader}</div>
              <MultiSelect
                className="keduall-form multi-select-input pr-4 custom-multi-select custom-pr-175 custom-placeholder keduall-typography text-16-semibold-600 text-default-txt w-full"
                options={transformedLanguages}
                itemTemplate={languageOptionTemplate}
                optionLabel="name"
                optionValue="code"
                placeholder={props.languages?.[0]?.name ?? props.translationData.languageSpokenFilterPlaceholder}
                selectOnFocus={false}
                showSelectAll={false}
                filter
                filterBy="filterText"
                appendTo="self"
                onShow={(e) => handleMultiSelectShow(e)}
                onHide={(e) => handleMultiSelectHide(e)}
                panelClassName="keduall-form dropdown-input-panel keduall-typography text-16-normal-400 text-default-txt w-webkit-fill-available"
                value={selectedSpokenLanguageState}
                onChange={(e) => setSelectedSpokenLanguage(e.value)}
                showClear={true}
                clearIcon={clearButtonTemplate(setSelectedSpokenLanguage, true, selectedSpokenLanguageState?.length)}
                dropdownIcon={dropdownIconTemplate}
                tooltip={getLanguageName(selectedSpokenLanguageState)}
                tooltipOptions={{
                  className: "keduall-tooltip",
                  position: "bottom",
                }}
              />
            </div>
            <div className="flex flex-column w-full md:w3">
              <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.teachingStyleFilterHeader}</div>
              <DropdownMultiSelectWithTitle
                ref={teachingStyleFilterRef}
                props={{ items: instructorStylesOptionState, labelKey: "value", valueKey: "key", placeholder: props.translationData.teachingStyleFilterPlaceholder }}
                value={selectedTeacherStyleState}
                onChange={setSelectedTeacherStyle}
              />
            </div>
          </div>

          {/* search by Tutor Name */}
          <div className="flex w-full input-search-container flex-column">
          <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.searchTextHeader}</div>
          <div className="relative flex w-full">
            {searchText && <i
              className="pi pi-times z-5 flex icon w-max absolute times-icon custom-icon cursor-pointer"
              onClick={(e) => {
                onSearchTextClear(e);
              }}
            />}
            
            <i className="pi pi-search absolute z-5 flex search-icon custom-icon"></i>
            <InputText
              className="keduall-form input-default-small keduall-typography text-16-semibold-600 text-default-txt w-full pr-7"
              value={searchText}
              placeholder={props.translationData.searchTextPlaceholder}
              onChange={(e) => {
                onSearchTextChange(e);
              }}
            ></InputText>
          </div>
          </div>
          <div className="flex flex-row justify-content-end gap-2 flex-wrap md:flex-nowrap mt-2 p-2">
              <Button
                label={props.translationData.buttonLabel.clearButtonLabel}
                className="keduall-buttons flex button-outlined-default-normal-secondary"
                onClick={() => {
                  onClear();
                  if (onCloseSearchSidebar) onCloseSearchSidebar();
                }}
              />
              <Button
                className="keduall-buttons flex button-filled-default-normal-primary"
                label={props.translationData.buttonLabel.searchButtonLabel}
                onClick={() => {
                  props?.onFilterClick();
                  if (onCloseSearchSidebar) onCloseSearchSidebar();
                }}
              />
            </div>
        </div>
      </div>
      {usingSidebar && (
        <Sidebar blockScroll={true} visible={searchSidebarVisible} onHide={() => onCloseSearchSidebar()} className="w-full sm:w-20rem md:w-30rem">
          <div class="w-full flex flex-column gap-4 mt-5 p-2">
            <div className="flex flex-column gap-3 w-full">
              {/* search by Tutor Name */}
              <div className="flex w-full input-search-container flex-column">
                <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.searchTextHeader}</div>
                <div className="relative flex w-full">
                  {searchText && <i
                    className="pi pi-times z-5 flex icon w-max absolute times-icon custom-icon cursor-pointer"
                    onClick={(e) => {
                      onSearchTextClear(e);
                    }}
                  />}
                  
                  <i className="pi pi-search absolute z-5 flex search-icon custom-icon"></i>
                  <InputText
                    className="keduall-form input-default-small keduall-typography text-16-semibold-600 text-default-txt w-full pr-7"
                    value={searchText}
                    placeholder={props.translationData.searchTextPlaceholder}
                    onChange={(e) => {
                      onSearchTextChange(e);
                    }}
                  ></InputText>
                </div>
              </div>

              <div className="flex flex-row gap-3 align-content-center justify-content-center flex-wrap w-full">
                <div className="flex flex-column w-full">
                  <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.lessonTimeFilterHeader}</div>
                  <DropdownSelectDayTime
                    ref={timeFilterRef}
                    commonProps={pickTimeProps}
                    selectedTimeState={selectedTimeState}
                    selectedDayState={selectedDayState}
                    onPickDay={setSelectedDay}
                    onPickTime={setSelectedTime}
                    dayOptions={daysOption}
                    labelKey="value"
                    valueKey="key"
                  />
                </div>
                <div className="flex flex-column w-full">
                  <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.tuitionFeeFilterHeader}</div>
                  <DropdownRangeSlider ref={tuitionFeeFilterRef} props={tuitonFeeProps} onChange={setSelectedPriceState} selectedPriceState={selectedPriceState ?? undefined} />
                </div>
                <div className="flex flex-column w-full">
                  <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.courseContentFilterHeader}</div>
                  <DropdownMultiSelectWithTitle
                    ref={courseContentFilterRef}
                    props={{ items: tagOptionState, labelKey: "value", valueKey: "key", placeholder: props.translationData.courseContentFilterPlaceholder }}
                    onChange={setSelectedCourseContent}
                    value={selectedCourseContentState}
                  />
                </div>
                <div className="flex flex-column w-full">
                  <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.sortByHeader}</div>
                  <Dropdown
                    className="keduall-form dropdown-input custom-height-auto dropdown-content-container no-padding custom-dropdown"
                    options={sortByProps.options}
                    placeholder={sortByProps.options[0] ?? sortByProps.placeholder}
                    panelClassName="keduall-form dropdown-input-panel keduall-typography text-16-normal-400 text-default-txt w-auto custom-index"
                    value={sortByState}
                    onChange={(e) => setSortBy(e.value)}
                    showClear={true}
                    clearIcon={clearButtonTemplate(setSortBy)}
                    dropdownIcon={dropdownIconTemplate}
                    collapseIcon={dropdownIconTemplate}
                    valueTemplate={valueTemplate}
                    style={{ height: "2.7rem" }}
                    appendTo="self"
                    onShow={(e) => handleDropdownShow(e)}
                    onHide={(e) => handleDropdownHide(e)}
                  />
                </div>
              </div>

              <div className="relative flex flex-row gap-3 align-content-center justify-content-center flex-wrap w-full">
                <div className=" flex flex-column w-full">
                  <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.nationalityFilterHeader}</div>
                  <MultiSelect
                    className="keduall-form multi-select-input pr-4 custom-multi-select custom-pr-175 custom-placeholder keduall-typography text-16-semibold-600 text-default-txt w-full"
                    options={props.listCountryOption}
                    optionLabel="name"
                    optionValue="code"
                    placeholder={props.listCountryOption?.[0]?.name ?? props.translationData.nationalityFilterPlaceholder}
                    itemTemplate={countryOptionTemplate}
                    selectOnFocus={false}
                    showSelectAll={false}
                    showClear={true}
                    filter
                    appendTo="self"
                    panelClassName="keduall-form dropdown-input-panel keduall-typography text-16-normal-400 text-default-txt w-webkit-fill-available"
                    onChange={(e) => setSelectedCountry(e.value)}
                    value={selectedCountryState}
                    clearIcon={clearButtonTemplate(setSelectedCountry, true, selectedCountryState?.length)}
                    dropdownIcon={dropdownIconTemplate}
                    tooltip={getOptionName(selectedCountryState)}
                    tooltipOptions={{
                      className: "keduall-tooltip",
                      position: "bottom",
                    }}
                    onShow={(e) => handleMultiSelectShow(e)}
                    onHide={(e) => handleMultiSelectHide(e)}
                  />
                </div>
                <div className="flex flex-column w-full">
                  <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.genderFilterHeader}</div>
                  <MultiSelect
                    className="keduall-form form-without-search multi-select-input custom-multi-select custom-placeholder keduall-typography text-16-semibold-600 text-default-txt w-full"
                    options={genderProps.options}
                    optionLabel="name"
                    optionValue="value"
                    placeholder={genderProps.options?.[0]?.name ?? genderProps.placeholder}
                    selectOnFocus={false}
                    showSelectAll={false}
                    appendTo="self"
                    panelClassName="keduall-form dropdown-input-panel keduall-typography text-16-normal-400 text-default-txt w-webkit-fill-available"
                    value={selectedGenderState}
                    showClear={true}
                    panelHeaderTemplate=""
                    onChange={(e) => setSelectedGender(e.value)}
                    clearIcon={clearButtonTemplate(setSelectedGender)}
                    dropdownIcon={dropdownIconTemplate}
                    tooltip={getGenderName(selectedGenderState)}
                    tooltipOptions={{
                      className: "keduall-tooltip",
                      position: "bottom",
                    }}
                    onShow={(e) => handleMultiSelectShow(e)}
                    onHide={(e) => handleMultiSelectHide(e)}
                  />
                </div>
                <div className="flex flex-column w-full">
                  <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.languageSpokenFilterHeader}</div>
                  <MultiSelect
                    className="keduall-form multi-select-input pr-4 custom-multi-select custom-pr-175 custom-placeholder keduall-typography text-16-semibold-600 text-default-txt w-full"
                    options={transformedLanguages}
                    itemTemplate={languageOptionTemplate}
                    optionLabel="name"
                    optionValue="code"
                    placeholder={props.languages?.[0]?.name ?? props.translationData.languageSpokenFilterPlaceholder}
                    selectOnFocus={false}
                    showSelectAll={false}
                    filter
                    filterBy="filterText"
                    appendTo="self"
                    panelClassName="keduall-form dropdown-input-panel keduall-typography text-16-normal-400 text-default-txt w-webkit-fill-available"
                    value={selectedSpokenLanguageState}
                    onChange={(e) => setSelectedSpokenLanguage(e.value)}
                    showClear={true}
                    clearIcon={clearButtonTemplate(setSelectedSpokenLanguage, true, selectedSpokenLanguageState?.length)}
                    dropdownIcon={dropdownIconTemplate}
                    tooltip={getLanguageName(selectedSpokenLanguageState)}
                    tooltipOptions={{
                      className: "keduall-tooltip",
                      position: "bottom",
                    }}
                    onShow={(e) => handleMultiSelectShow(e)}
                    onHide={(e) => handleMultiSelectHide(e)}
                  />
                </div>
                <div className="flex flex-column w-full">
                  <div className="flex keduall-typography text-14-normal-400 text-default-txt mb-1 ">{props.translationData.teachingStyleFilterHeader}</div>
                  <DropdownMultiSelectWithTitle
                    ref={teachingStyleFilterRef}
                    props={{ items: instructorStylesOptionState, labelKey: "value", valueKey: "key", placeholder: props.translationData.teachingStyleFilterPlaceholder }}
                    value={selectedTeacherStyleState}
                    onChange={setSelectedTeacherStyle}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-row justify-content-end gap-2 flex-wrap md:flex-nowrap mt-5 p-2">
            <Button
              label={props.translationData.buttonLabel.clearButtonLabel}
              className="keduall-buttons flex button-outlined-default-normal-secondary"
              onClick={() => {
                onClear();
                if (onCloseSearchSidebar) onCloseSearchSidebar();
              }}
            />
            <Button
              className="keduall-buttons flex button-filled-default-normal-primary"
              label={props.translationData.buttonLabel.searchButtonLabel}
              onClick={() => {
                props?.onFilterClick();
                if (onCloseSearchSidebar) onCloseSearchSidebar();
              }}
            />
          </div>
        </Sidebar>
      )}
    </>
  );
};

export default TrainerHeroSection;
